<template>
  <span>
    <label
      :style="primaryLabelStyle"
      :class="primaryLabelClassName"
      :for="labelForId ? labelForId : null"
    >
      {{ primaryLabel }}
    </label>
    <label :style="secondaryLabelStyle" :class="secondaryLabelClassName">
      {{ secondaryLabel }}
    </label>
    <BaseIcon
      v-if="infoIconReq"
      :name="infoIconName"
      class="info-icon"
      width="0.938rem"
      height="0.938rem"
      v-tooltip:top="infoIconTooltipText"
    />
  </span>
</template>

<script>
export default {
  props: {
    primaryLabel: { type: String, required: true },
    secondaryLabel: { type: String, required: false, default: '' },
    primaryLabelClassName: { type: String, default: 'cus-mod-label' },
    secondaryLabelClassName: { type: String, default: 'cus-mod-sub-label' },
    primaryLabelStyle: { type: Object, default: () => {} },
    secondaryLabelStyle: { type: String, default: null },
    /**
     *
     *Boolean set to display info icon
     *
     */
    infoIconReq: { type: Boolean, default: false },
    /**
     *
     *Info icon name
     *
     */
    infoIconName: { type: String, default: 'info' },
    /**
     *
     *Tooltip text displayed on hover of info icon
     *
     */
    infoIconTooltipText: { type: String, default: '' },
    /**
     *
     *Input id is passed to the respective label
     *
     */
    labelForId: { type: String, default: '' },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.cus-mod-label {
  font-family: $semi-bold;
  color: $font-primary;
  font-size: 1.1rem;
  margin-right: 0.3125rem;
}
.cus-mod-sub-label {
  font-family: $regular;
  color: $color-brand-accent;
  font-size: 0.875rem;
}
.info-icon {
  margin-left: 0.469rem;
  @include svg-fill($color-brand-accent);
}
</style>
